import { ActionTypes } from "../constants/actionTypes";

const initialState = {
  allSealNumber: {},
};

export default function tourSealNumberReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.GET_TOUR_SEAL_DETAILS:
      return {
        ...state,
        allSealNumber: payload,
      };
    case ActionTypes.CLEAR_TOUR_SEAL_DETAILS:
      return {
        ...state,
        allSealNumber: {},
      };
    default:
      return state;
  }
}
